export const TicketActionTypes = {
  SET_SELECTED_TICKET: "@@ticket/SET_SELECTED_TICKET",
  SET_TICKET_NOT_FOUND: "@@ticket/SET_TICKET_NOT_FOUND",
  SET_TICKET_LIST: "@@ticket/SET_TICKET_LIST",
  SET_TICKET_LIST_SELECTED_ID: "@@ticket/SET_TICKET_LIST_SELECTED_ID",
  UPDATE_TICKET: "@@ticket/UPDATE_TICKET",
};
